import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadEventsPage } from './daily-leg-load-events';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLegLoadEventsPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLegLoadEventsPage),
  ],
})
export class DailyLegLoadEventsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-events/daily-leg-load-events.module.ts